import { _$, $$ } from './utils'

document.addEventListener('DOMContentLoaded', () => {
  // Set nav menu initial attributes.
  const nav = _$('primary-menu')
  if (nav) {
    nav.setAttribute('aria-hidden', 'true')
    nav.style.display = 'none'
  }

  // Adjust all posts grid item header heights.
  // Defer until after initial layout to avoid forced reflow
  const postHeaders = $$('.blog-posts .entry-header')
  if (postHeaders && postHeaders.length) {
    requestAnimationFrame(() => {
      const postMaxHeight = Math.max(...Array.from(postHeaders).map((a) => a.offsetHeight))
      postHeaders.forEach((a) => {
        a.style.height = `${postMaxHeight}px`
      })
    })
  }
})
